const QUANTITY_REQUIRED_IN_POPUP = ["Q_VEHICLE", "ROOM"]; // "Q_SIM",
const QUANTITY_REQUIRED = ["ADULT", "PERSON", "Q_SIM"];
const VISIBLE_CHECKBOX: ProdAttrNameSingleCheckbox[] = [
  "EXTRA_OPTION",
  "ROOM_OPTION",
  "LUGGAGE",
  "AIRPORT",
];

export const PA_NAME = {
  DEFAULT: [
    "PASS",
    "TICKET",
    "TOUR",
    "MUSICAL",
    "ESIM",
  ] as ProdAttrNameDefault[],
  CALENDAR: [
    "MUSICAL_CALENDAR",
    "DAY_TOUR_CALENDAR",
    "NIGHT_TOUR_CALENDAR",
    "TICKET_CALENDAR",
    "PRIORITY_CALENDAR",
    "ESIM_CALENDAR",
  ] as ProdAttrNameCalendar[],
  VISIBLE_CHECKBOX,
  CHECKBOX: [
    "PREMIUM_PLUS",
    ...VISIBLE_CHECKBOX,
  ] as ProdAttrNameSingleCheckbox[],
  QUANTITY_REQUIRED,
  QUANTITY_REQUIRED_IN_POPUP,
  QUANTITY: [
    ...QUANTITY_REQUIRED_IN_POPUP,
    ...QUANTITY_REQUIRED,
    "CHILD",
  ] as ProdAttrNameQuanity[],
  OTHER: [
    "SIM",
    "GPS",
    "DROP_OFF_LOCATION",
    "MAX_PRODUCTS",
    "CALENDAR_CONFIG",
  ] as ProdAttrNameOther[],
  PARTY_3RD: ["TICKET_3RDPARTY", "MUSICAL_3RDPARTY"] as ProdAttrName3rdParty[],
  TOUR_INFO: [
    "PICKUP_TIME",
    "RETURN_TIME",
    "PICKUP_LOCATION",
    "RETURN_LOCATION",
    "DURATION",
    "GROUP_SIZE",
    "LANGUAGE",
    "AGE",
    "MEAL",
  ] as ProdAttrNameTourInfo[],
};

export const PA_VALUE_FIELDS: ProdValueField[] = [
  ...PA_NAME.DEFAULT,
  ...PA_NAME.CALENDAR,
  ...PA_NAME.CHECKBOX,
  ...PA_NAME.QUANTITY,
  ...PA_NAME.OTHER,
  ...PA_NAME.PARTY_3RD,
];

export const PA_GROUP = {
  ADDITIONAL_OPTIONS: [
    "EXTRA_OPTION",
    "ROOM_OPTION",
    "PREMIUM_PLUS",
  ] as ProdAttrName[],
};

export const PA_ABLE2TRANSLATE: ProdAttrName[] = [
  "ROOM_OPTION",
  "EXTRA_OPTION",
  "AIRPORT",
  "LUGGAGE",
];
